import React from "react";
import {Session, User} from "../types/Types";
import {V2GlassChip, V2GlassSurface} from "../shared/v2/V2Glass";
import UserTag from "../users/tag/UserTag";
import "./LeaderboardV2.css";

export interface LeaderboardV2Row {
    user: User;
    value: number | string;
    session?: Session;
}

interface Props {
    rows: Array<LeaderboardV2Row>;
    linksToTab: string;
    emptyMessage: string;
}

function LeaderboardV2Rows(props: Props) {
    return (
        <>
            {props.rows.map((row, index) => {
                const displayValue = typeof row.value === "number" ? row.value.toLocaleString("en-US") : row.value;
                const rank = index + 1;
                const rankDigitCount = rank.toString().length;
                const rankSizeClass = rankDigitCount >= 4
                    ? " leaderboard-v2-rank-wide"
                    : rankDigitCount >= 3
                        ? " leaderboard-v2-rank-compact"
                        : "";

                return (
                    <V2GlassSurface className="leaderboard-v2-user-row v2-glass-list-row" key={row.user.id}>
                        <V2GlassChip className={`leaderboard-v2-rank${index < 3 ? ` leaderboard-v2-rank-${rank}` : ""}${rankSizeClass}`}>
                            {rank}
                        </V2GlassChip>
                        <div className="leaderboard-v2-user">
                            <div className="leaderboard-v2-user-tag">
                                <UserTag
                                    user={row.user}
                                    session={row.session}
                                    visit={undefined}
                                    padRight={false}
                                    hideLocationDot={false}
                                    linksToTab={props.linksToTab}
                                    chipClassName="v2-glass-user-chip"
                                />
                            </div>
                        </div>
                        <V2GlassChip className="leaderboard-v2-count">
                            {displayValue}
                        </V2GlassChip>
                    </V2GlassSurface>
                );
            })}
            {props.rows.length === 0 && <div className="leaderboard-v2-empty">{props.emptyMessage}</div>}
        </>
    );
}

export default LeaderboardV2Rows;
